export default "__VITE_ASSET__Crpq8gOL__"